import { render, staticRenderFns } from "./SuggestionHeader.vue?vue&type=template&id=d44be6c4&"
import script from "./SuggestionHeader.vue?vue&type=script&lang=js&"
export * from "./SuggestionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionHeader.vue?vue&type=style&index=0&id=d44be6c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports